
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@ember-data/request/-embroider-implicit-modules.js";
import "@fortawesome/ember-fontawesome/-embroider-implicit-modules.js";
import "@warp-drive/ember/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-truth-helpers/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "ember-intl/-embroider-implicit-modules.js";
